export enum SortBy {
	Relevance = 'RELEVANCE',
	Name = 'NAME',
	Rating = 'RATING',
	Recommended = 'RECOMMENDED',
	EntryRequirements = 'ENTRY_REQUIREMENTS',
	Date = 'DATE',
}

export interface Sort {
	text: string;
	sortBy: SortBy;
	sortDir?: SortDir;
}

export type SortDir = 'ASC' | 'DESC';
